/** This includes all headers of the Cookie Monster Framework and their relevant data */
const headers = { infoMenu: 1, optionsMenu: 1 };
export default headers;
